const FillArrow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={8}
    fill="none"
    {...props}
  >
    <path fill="#2C2C2C" d="M7.5 8 15 0H0l7.5 8Z" />
  </svg>
);
export default FillArrow;
